module.exports = __webpack_public_path__ + "static/img/40002 (3).f8887dc.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40002 (3).webp
// module id = u4hJ
// module chunks = 14